import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const truelarkStyles = {
  pageContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  `,

  locationButton: css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    padding: ${theme.spacing(1)} ${theme.spacing(2)};
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.neutral50};
    border-radius: 4px;
    cursor: pointer;
  `,

  cardsGrid: css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.spacing(3)};
    align-items: start;
    @media (max-width: ${breakpoints.mobile.max}px) {
      grid-template-columns: 1fr;
    }
  `,

  fullWidthCell: css`
    grid-column: 1 / -1;
  `,

  detailsFieldsGrid: css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 ${theme.spacing(4)};
    @media (max-width: ${breakpoints.mobile.max}px) {
      grid-template-columns: 1fr;
    }
  `,

  detailsFieldRow: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.5)};
    padding: ${theme.spacing(1)} 0;
    border-bottom: 1px solid ${theme.colors.neutral10};
    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  `,

  modalBody: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
};
